/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "./BaseCom"
import Breadcrumb from "./Breadcrumb";
import LoadingAlert from "./LoadingAlert";
import withParams from "./WithParams";
import { qreq } from "../shared/qrequest";
import Contact from "./Contact";
import { SidebarGlobal } from "./_Sidebar";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fa from '@fortawesome/free-solid-svg-icons';
import MessageDialog from "./MessageDialog";
import L from "./Lang";

class ContactView extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            user: null,
            item: {
                roles: [],
                accounts: []
            },
            saving: false
        };
        if (this.props.params.id) {
            this.id = this.props.params.id;
            this.state.loading = true;
        }

        this.submit = this.submit.bind(this);

    }

    componentDidMount() {
        if (this.id) {
            qreq.get('/api/contact/get/' + this.id, j => {
                if (j.errorCode)
                    alert(j.errorMessage);
                else {
                    this.state.item = j.item;
                    this.setState({ item: this.state.item });
                }
                this.setState({ loading: false });
            }, e => {
                this.goBack();
            });
        }
        SidebarGlobal.setSubNav(<><button type="button" className="btn btn-success" onClick={() => document.getElementById('c-submit').click()}><FontAwesomeIcon icon={fa.faSave} /> <L>Save</L></button></>);

    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    submit(e) {
        e.preventDefault();
        this.setState({ item: this.state.item, saving: true });

        qreq.post('/api/contact/save', this.state.item, (j) => {
            if (j.errorCode !== 0)
                alert(j.errorMessage);
            else
                this.goBack();

            this.setState({ saving: false });
        });
    }

    render() {
        if (this.state.loading)
            return (<div className="container-fluid"><h1><L>Edit Contact</L></h1><LoadingAlert /></div>);

        SidebarGlobal.setSubNav(<><button type="button" className="btn btn-success" onClick={() => document.getElementById('c-submit').click()}><FontAwesomeIcon icon={fa.faSave} /> <L>Save</L></button></>);

        return <div className="container-fluid">
            <form onSubmit={this.submit}>
                <h1><L>Edit Contact</L></h1>
                <Breadcrumb path={[['Contacts', '/contact/list'], ['Edit']]} />
                <Contact item={this.state.item} edit onChange={() => this.setState({ item: { ...this.state.item } })} />
                {this.state.saving ? (<MessageDialog title="Saving" message="Processing..." />) : (<>
                    <div className="d-none">
                        <button id="c-submit" type="submit" className="btn btn-success d-inline-block"><L>Save</L></button>
                        <button type="button" className="btn btn-secondary d-inline-block ms-1" onClick={this.goBack}><L>Cancel and Go Back</L></button>
                    </div></>)}
            </form>
        </div>;
    }
}

export default withParams(ContactView);